import { useLayoutEffect } from 'react'
import { InternalAxiosRequestConfig } from 'axios'

import { useAxiosInstance } from './AxiosInstanceProvider.js'

export const useRequestInterceptor = (
  onFulfilled?: (value: InternalAxiosRequestConfig) => InternalAxiosRequestConfig | Promise<InternalAxiosRequestConfig>
): void => {
  const axiosInstance = useAxiosInstance()

  useLayoutEffect(() => {
    const id = axiosInstance.interceptors.request.use(onFulfilled)

    return () => {
      axiosInstance.interceptors.request.eject(id)
    }
  }, [axiosInstance, onFulfilled])
}
